import React from "react";
import WasslaLogo from './WasslaLogo';

/**
 * BrandLogo Component
 * - variant="header" → medium logo for header (44px)
 * - variant="auth" → large logo for sign in/sign up (90px)
 */
export function BrandLogo({ variant = "header", onClick }) {
  if (variant === "auth") {
    return (
      <div className="authBrand">
        <WasslaLogo size="large" className="authLogo" />
      </div>
    );
  }

  const Component = onClick ? 'button' : 'div';
  const props = onClick ? { onClick, type: 'button', 'aria-label': 'Wassla' } : {};

  return (
    <Component className="brandLogo" {...props}>
      <WasslaLogo size="headerLarge" />
    </Component>
  );
}

export default BrandLogo;
